// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GetPaymentProcessorData
 */
export interface GetPaymentProcessorData {
  /**
   * Stripe customer identifier, present when type is Stripe.
   * @type {string}
   * @memberof GetPaymentProcessorData
   */
  stripeCustomerID?: string;
}

/**
 * Check if a given object implements the GetPaymentProcessorData interface.
 */
export function instanceOfGetPaymentProcessorData(
  value: object,
): value is GetPaymentProcessorData {
  return true;
}

export function GetPaymentProcessorDataFromJSON(
  json: any,
): GetPaymentProcessorData {
  return GetPaymentProcessorDataFromJSONTyped(json, false);
}

export function GetPaymentProcessorDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetPaymentProcessorData {
  if (json == null) {
    return json;
  }
  return {
    stripeCustomerID:
      json['stripeCustomerID'] == null ? undefined : json['stripeCustomerID'],
  };
}

export function GetPaymentProcessorDataToJSON(
  json: any,
): GetPaymentProcessorData {
  return GetPaymentProcessorDataToJSONTyped(json, false);
}

export function GetPaymentProcessorDataToJSONTyped(
  value?: GetPaymentProcessorData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    stripeCustomerID: value['stripeCustomerID'],
  };
}
